import {API_HOST} from '../apis';

/**
 * Converts relative media URLs to absolute URLs pointing to the Django backend
 * @param {string} imageUrl - The image URL from the API (can be relative or absolute)
 * @returns {string} - Absolute URL pointing to the correct backend
 */
export const getAbsoluteImageUrl = imageUrl => {
  if (!imageUrl) return null;

  // If it's already an absolute URL (starts with http/https), return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }

  // If it's a relative URL starting with /mediafiles/, prepend API_HOST
  if (imageUrl.startsWith('/mediafiles/')) {
    return `${API_HOST}${imageUrl}`;
  }

  // If it's a relative URL but doesn't start with /, prepend API_HOST + /
  if (!imageUrl.startsWith('/')) {
    return `${API_HOST}/${imageUrl}`;
  }

  // For any other relative URL, prepend API_HOST
  return `${API_HOST}${imageUrl}`;
};
